<template>
    <el-form v-if="isInit" class="color-picker" ref="form" :model="field" :label-width="field.name ? '120px' : '0'">
        <el-form-item
            class="input-row"
            prop="def_val"
            :rules="fieldRules">
            <div v-if="field.name" slot="label" class="label-item common">
                <p class="label-text">{{ field.desc }}</p>
                <el-tooltip class="item" effect="light" placement="bottom-start">
                    <div slot="content">
                        - name: <strong>{{ field.name }}</strong><br/>
                    </div>
                    <i class="label-icon el-icon-info"></i>
                </el-tooltip>
            </div>
            <el-color-picker v-model="field.def_val" @change="valChangeHandler"></el-color-picker>
        </el-form-item>
    </el-form>
</template>
<script>
import moment from 'moment';

export default {
    name: 'color-picker',
    props: ['field', 'autoInit'],
    data() {
        return {
            fieldRules: {
                required: this.field.require,
                message: `请填写'${this.field.desc}'的内容`,
                trigger: 'blur'
            },
            isInit: this.autoInit
        }
    },
    components: {
    },
    watch: {
    },
    methods: {
        valChangeHandler(e) {
            // 适配基本类型数据的变更
            this.$emit('val-change', e);
        },
        initData() {
            this.isInit = true;
        },
        fieldBeReady() {
            // 确认组件是否就绪
            return this.$refs['form'];
        },
        getResField() {
            let isValidate = false;
            this.$refs['form'].validate((valid) => {
                if (valid) {
                    isValidate = true;
                } else {
                    isValidate = false;
                }
            });
            if (!isValidate) {
                return;
            }
            return this.field;
        }
    },
    computed: {
    },
    mounted() {
    }
}
</script>
<style lang="less">
    @import (reference) '../../styles/public.less';
    .color-picker {
        .label-item();
    }
</style>



// WEBPACK FOOTER //
// src/components/compEditForm/colorPicker.vue